import { useTypedFormikContext } from "hooks/useTypedFormikContext";
import { RefObject, useEffect } from "react";
import { FormPendingCount, Section } from "types/Models/Filing";
import { getFieldChecks } from "util/filingForm/getFieldChecks";
import { getFieldKeysOnPage } from "util/filingForm/getFieldKeysOnPage";
import { getFormPendingCount } from "util/filingForm/getFormPendingCount";

type FormPendingCountTrackerProps = {
  formRef: RefObject<HTMLFormElement>;
  sections: Section[];
  isCompletingTask: boolean;
  addedRepeatableIds: Record<string, number>;
  onChange: (update: (current: FormPendingCount) => FormPendingCount) => void;
};

const isSameCount = (first: FormPendingCount, second: FormPendingCount) =>
  JSON.stringify(first) === JSON.stringify(second);

/**
 * Keeps the pending count equal to what blocks submit. Which fields are
 * visible is read from the rendered page, so it runs after each render.
 */
export const FormPendingCountTracker = ({
  formRef,
  sections,
  isCompletingTask,
  addedRepeatableIds,
  onChange,
}: FormPendingCountTrackerProps) => {
  const { values } = useTypedFormikContext<Record<string, unknown>>();

  useEffect(() => {
    const count = getFormPendingCount(
      getFieldChecks({
        sections,
        values,
        fieldKeysOnPage: getFieldKeysOnPage(formRef.current),
        isCompletingTask,
        addedRepeatableIds,
      })
    );

    onChange((current) => (isSameCount(current, count) ? current : count));
  });

  return null;
};
